var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"home"}},[_c('h2',[_c('router-link',{attrs:{"to":"calculator"}},[_vm._v("Drawing Generator - Customize, render, and share your design as a DXF or URL")])],1),_c('demo-3d')],1)}
var staticRenderFns = []

export { render, staticRenderFns }